import { find, get } from 'lodash';

function formatEmail(emailAdresses = []) {
  const primaryEmail = find(emailAdresses, { is_primary: true });
  const firstEmail = get(emailAdresses, '[0]');

  return get(primaryEmail || firstEmail, 'email_address', '');
}

export default formatEmail;



// WEBPACK FOOTER //
// ./public/js/utils/formatEmail.js